// DO NOT EDIT THIS FILE. It should be automatically generated by running
// pnpm generate-product-schemas
import { format } from 'date-fns/format'
import { sub } from 'date-fns/sub'
import * as z from 'zod'

import * as constants from '@nxt-insurance/constants'

// This is the base schema that can be extended when using it in configs
export const BaseSchema_DogLiabilityV1GetsafeAt = z.object({
  dogs: z
    .array(
      z.object({
        id: z.string().optional(),
        name: z.string().min(1).optional(),
        breed: z.string().min(1).optional(),
        breed_class: z.preprocess((val) => {
          if (val === '' || val === undefined) {
            return undefined
          }
          return Number(val)
        }, z.number().int()),
        is_pure_breed: z.boolean().optional(),
        shoulder_height_above_threshold: z.boolean().optional(),
      })
    )
    .max(9),
  born_on: z
    .union([z.number(), z.string(), z.date()])
    .pipe(
      z.coerce
        .date()
        .min(sub(new Date(), { years: 120 }))
        .max(sub(new Date(), { years: 18 }))
    )
    .transform((value) => {
      return format(value, constants.SERVER_DATE_FORMAT)
    })
    .optional(),
  tariff_line: z.enum(['comfort', 'premium']),
  deductible_amount: z.coerce
    .string()
    .pipe(z.enum(['0', '150', '300']))
    .pipe(z.coerce.number()),
  sos_help_coverage: z.boolean(),
  cancelled_by_previous_insurer: z.coerce
    .string()
    .pipe(z.enum(['false']))
    .transform(() => false)
    .optional(),
  prior_damages_in_last_5_years: z.coerce
    .string()
    .pipe(z.enum(['0', '1', '2']))
    .pipe(z.coerce.number())
    .optional(),
})

const Schema_DogLiabilityV1GetsafeAt = BaseSchema_DogLiabilityV1GetsafeAt

export default Schema_DogLiabilityV1GetsafeAt
